import { render, staticRenderFns } from "./source-data-tab.vue?vue&type=template&id=b006a5b0"
import script from "./source-data-tab.vue?vue&type=script&lang=js"
export * from "./source-data-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports